import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  loadingSession: false,
  loadingDetail: false,
  loadingUpdateSession: false,
  loadingUpdateDetail: false,
});

export default {
  namespaced: true,
  state: initState(),
  mutations: {
    LOAD_LIST_SESSION: (s, data) => (s.loadingSession = data),
    LOAD_PAYOUT_DETAIL: (s, data) => (s.loadingDetail = data),
    LOAD_UPDATE_SESSION: (s, data) => (s.loadingUpdateSession = data),
    LOAD_UPDATE_DETAIL: (s, data) => (s.loadingUpdateDetail = data),
  },

  actions: {
    async getListPayoutRecalculationSession({ commit }, params) {
      commit("LOAD_LIST_SESSION", true);
      try {
        const res = await this.$api.get(
          "/v1/portal/betslips/payout-recalculation-sessions",
          {
            params,
          }
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_LIST_SESSION", false);
      }
    },
    async getPayoutRecalculationDetail({ commit }, params) {
      commit("LOAD_PAYOUT_DETAIL", true);
      try {
        const { sessionId, ...rest } = params;
        const res = await this.$api.get(
          `/v1/portal/betslips/payout-recalculation-details/${sessionId}`,
          {
            params: rest,
          }
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_PAYOUT_DETAIL", false);
      }
    },
    async updatePayoutSession({ commit }, params) {
      commit("LOAD_UPDATE_SESSION", true);
      try {
        const { sessionId, ...rest } = params;
        const res = await this.$api.put(
          `/v1/portal/betslips/payout-recalculation-sessions/${sessionId}`,
          rest
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_UPDATE_SESSION", false);
      }
    },
    async updatePayoutByBetslip({ commit }, params) {
      commit("LOAD_UPDATE_DETAIL", true);
      try {
        const { id, ...rest } = params;
        const res = await this.$api.put(
          `/v1/portal/betslips/payout-recalculation-details/${id}`,
          rest
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_UPDATE_DETAIL", false);
      }
    },
  },
};
